// Who may do what on the Resident Directory. Mirrors the server gate in
// Server/src/routes/mastersheet/resident-directory.routes.ts (companyOnly on /template and
// /import): the client hides what the server would refuse, so nobody is shown a button that 403s.

/** The role on the stored login, whatever shape the login flow saved it in. */
export const roleOfUser = (userData) => String(userData?.role || userData?.userData?.role || "").toLowerCase();

/** Importing residents from Excel (and fetching the template) is the company login's alone. */
export const canImportRoster = (userData) => roleOfUser(userData) === "company";

/** Notices go out from the company login (any property, or company-wide) and from managers (their properties). */
export const canSendNotices = (userData) => ["company", "manager"].includes(roleOfUser(userData));

/** Only the company login may address every property at once. */
export const canSendCompanyWide = (userData) => roleOfUser(userData) === "company";
